import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

defineBlock({
    type: 'var_set_string',
    colour: '#FF4081',
    tooltip: '文字列変数に値を代入します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/var_string.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('変数セット', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('文字列'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'field',
                    name: 'VAR_LABEL',
                    instance: () => new FieldVariableLabel('設定する変数', { fontWeight: 'normal', varType: 'String' }),
                },
                { type: 'label', text: 'に' },
            ],
        },
        {
            kind: 'value',
            name: 'VALUE',
            check: 'String',
            shadow: { type: 'string', fields: { TEXT: '' } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'を入れる ' }],
        },
    ],
    onInit(this: Blockly.Block) {
        this.setOutputShape(3);
        if (this.isShadow()) {
            (this as Blockly.BlockSvg).render();
        }
    },
});
